<template>
    <div class="bigView" :style="{'backgroundImage': backgroundImg ? backgroundImg : '', 'backgroundColor': backgroundImg ? '#141722' : ''}">
        <div class="bigView__icon" v-if="icon">
            <img :src="'/static/svg/icons/'+icon+'.svg'" alt="">
        </div>
        <div class="bigView__country">
            <span class="bigView__country-name" v-html="countryName"></span>
            <div class="bigView__country-flag">
                <img :src="countryFlag" :alt="countryName">
            </div>
        </div>
        <h2 class="bigView__title">
            <span class="bigView__title-number" v-html="titleNumber"></span>
            <span class="bigView__title-text" v-html="titleText"></span>
        </h2>
        <p class="bigView__text" v-html="contentText"></p>
    </div>
</template>

<script>

    import icons from '@/assets/svg/icons'

    export default {
        name: 'BigView',
        props: {
            backgroundImg: String,
            icon: {
                type: String,
                required: true
            },
            countryName: {
                type: String,
                required: true
            },
            countryFlag: {
                type: String,
                required: true
            },
            titleNumber: {
                type: Number,
                required: true
            },
            titleText: {
                type: String,
                required: true
            },
            contentText: {
                type: String,
                required: true
            }
        },
        data() {
            return {}
        }
    }
</script>



// WEBPACK FOOTER //
// bigView.vue?51c60b41